import { motion } from 'framer-motion';
import {
  Github,
  Linkedin,
  Mail,
  Twitter,
  Facebook,
  Instagram,
  BookOpen,
  GraduationCap,
} from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      icon: Github,
      href: 'https://github.com/BakangMonei',
      label: 'GitHub',
      color: 'hover:text-gray-300',
    },
    {
      icon: Linkedin,
      href: 'https://www.linkedin.com/in/monei-bakang-mothuti-b715361b5/',
      label: 'LinkedIn',
      color: 'hover:text-blue-400',
    },
    {
      icon: Twitter,
      href: 'https://x.com/MoneiBakang',
      label: 'X (Twitter)',
      color: 'hover:text-gray-300',
    },
    {
      icon: Facebook,
      href: 'https://www.facebook.com/bakangmonei.mothuti',
      label: 'Facebook',
      color: 'hover:text-blue-500',
    },
    {
      icon: Instagram,
      href: 'https://www.instagram.com/moneibakangmothuti/',
      label: 'Instagram',
      color: 'hover:text-pink-400',
    },
    {
      icon: BookOpen,
      href: 'https://www.researchgate.net/profile/Bakang-Motshegwe?ev=hdr_xprf',
      label: 'ResearchGate',
      color: 'hover:text-green-400',
    },
    {
      icon: GraduationCap,
      href: 'https://orcid.org/0009-0003-2318-8309',
      label: 'ORCID',
      color: 'hover:text-green-500',
    },
    {
      icon: Mail,
      href: 'mailto:bakangmonei2@gmail.com',
      label: 'Email',
      color: 'hover:text-red-400',
    },
  ];

  return (
    <footer className="border-t border-white/10 bg-black px-4 py-12 sm:px-6 lg:px-8">
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col items-center justify-between gap-6 md:flex-row">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-sm text-gray-400"
          >
            © {currentYear} — Built by Monei Bakang Mothuti
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="flex flex-wrap items-center justify-center gap-4 md:gap-6"
          >
            {socialLinks.map((link, index) => {
              const Icon = link.icon;
              return (
                <motion.a
                  key={index}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={link.label}
                  whileHover={{ scale: 1.2, y: -2 }}
                  whileTap={{ scale: 0.9 }}
                  className={`text-gray-500 ${link.color} transition-colors duration-300`}
                >
                  <Icon className="h-5 w-5" />
                </motion.a>
              );
            })}
          </motion.div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
